export function ComponentFAQLexicon() {
  $('.section-faq-lexicon h3').on('click', function (e) {
    e.preventDefault();

    $(this).next().slideToggle();
  });
}
